import React from 'react';
import Navbar from "../Common/Navbar.jsx";
import FaqQuestions from './FaqQuestions.jsx';
import Footer from '../Common/Footer.jsx';

const Faq = () => {
    return (
        <>
            <div className="faq_container">
                <div className="faq_bg">
                    <Navbar />
                    <div className="faq_head_container">
                        <h1>FAQ</h1>
                        <p className="faq_head_subtitle">
                            Get quick answers to common questions about our tax compliance, accounting, and business advisory services.
                        </p>
                    </div>
                </div>
            </div>
            {/* FAQ QUESTIONS START */}
            <FaqQuestions />
            {/* Footer */}
            <Footer />
        </>
    )
}

export default Faq;